import {
  EnvironmentProviders,
  effect,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { CurrentUser } from '@app/shared/auth';
import {
  AnalyticsTracker,
  provideGoogleAnalytics,
} from '@classi/ngx-google-analytics';

/**
 * Google Analyticsのためにgtag.jsを読み込む
 *
 * NOTE: 環境ごとにGAのトラッキングIDを切り替えるため、scriptタグはindex.htmlに直接書くのではなく動的に生成するようにしている（Angular CLIではindex.htmlの中に変数埋め込みができない）
 */
export function setupGoogleAnalytics(id: string | null) {
  if (id == null) {
    // コンソールに出力するだけのダミー関数を設定
    globalThis.gtag = (...args: unknown[]) => {
      console.log(`gtag(${args.map((a) => JSON.stringify(a)).join(', ')})`);
    };
    return;
  }

  // gtag.jsの読み込み
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  script.async = true;
  document.getElementsByTagName('head')[0].appendChild(script);

  // gtag.jsの初期化
  const gtagEl = document.createElement('script');
  const gtagBody = document.createTextNode(`
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '${id}');
    `);
  gtagEl.appendChild(gtagBody);
  document.body.appendChild(gtagEl);
}

/**
 * Google Analyticsによるトラッキングのためのプロバイダーを提供する
 */
export function provideGoogleAnalyticsTracker(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideGoogleAnalytics({ startTrackingOnInit: true }),
  ]);
}

/**
 * ログインユーザーが変更されるたびに、ユーザー情報をGAに送信する副作用を導入する。
 */
export function provideGoogleAnalyticsUserBinding(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const currentUser = inject(CurrentUser);
      const tracker = inject(AnalyticsTracker);
      effect(() => {
        const user = currentUser.get();
        if (user === null) {
          tracker.clearUserContext();
        } else {
          tracker.setUserContext({ id: user.id });
        }
      });
    }),
  ]);
}
